import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { Features } from '../../assets/features/Features';


const Nav = () => {
    const location = useLocation();
    const { language } = useLanguage();
    const currentPath = location.pathname;

    const isActive = (path) => {
        if (path === "/") {
            return currentPath === "/";
        }
        return currentPath === path;
    };

    return (
        <nav className="mainmenu-nav">
            <ul className="mainmenu" style={{margin: 0, padding: 0, display: 'flex', alignItems: 'center'}}>
                <li style={{margin: '0 12px'}}>
                    <Link 
                        to="/" 
                        className={isActive("/") ? "active" : ""}
                    >
                        {Features.NAV.HOME[language]}
                    </Link>
                </li>
                <li style={{margin: '0 12px'}}>
                    <Link 
                        to="/sobre-nos" 
                        className={isActive("/sobre-nos") ? "active" : ""}
                    >
                        {Features.NAV.ABOUT[language]}
                    </Link>
                </li>
                <li style={{margin: '0 12px'}}>
                    <Link 
                        to="/dicas" 
                        className={isActive("/dicas") ? "active" : ""}
                    >
                        {Features.NAV.TIPS[language]}
                    </Link>
                </li>
                <li style={{margin: '0 12px'}}>
                    <Link 
                        to="/servicos" 
                        className={isActive("/servicos") ? "active" : ""}
                    >
                        {Features.NAV.SERVICES[language]}
                    </Link>
                </li>
                <li style={{margin: '0 12px'}}>
                    <Link 
                        to="/contactos" 
                        className={isActive("/contactos") ? "active" : ""}
                    >
                        {Features.NAV.CONTACT[language]}
                    </Link>
                </li>
            </ul>
        </nav>
    )
}

export default Nav;